import { useEffect, useState } from 'react';
import 'cross-fetch/polyfill';
import Link from 'next/link';
import Image from 'next/image';
import { decode } from 'he';
import { get } from 'lodash';
import { formatPostTitle } from '../../util';

const RelatedPosts = ({ post }) => {
  const [relatedPosts, setRelatedPosts] = useState([]);

  useEffect(() => {
    const url = `${process.env.NEXT_PUBLIC_RELATED_BLOG_POSTS_API}/${post.id}?limit=5&_embed=1`;
    async function fetchRelated() {
      const res = await fetch(url);
      const data = await res.json();
      setRelatedPosts(data);
    }
    fetchRelated();
  }, [post.id]);

  if (!relatedPosts.length > 0) {
    return (
      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 mb-3">
        <div className="col mb-3">No Related Posts.</div>
      </div>
    );
  }

  return (
    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 mb-3">
      {relatedPosts.map((related, i) => {
        const imgUrl = get(
          related,
          '_embedded["wp:featuredmedia"][0].media_details.sizes.medium.source_url',
          '/images/CR_default-image.jpg'
        );
        const alt = get(related, '_embedded["wp:featuredmedia"][0].caption.rendered', null);
        return (
          <div className="col mb-3" key={i}>
            <Link href={related.link} passHref>
              <a className="article-card" href={related.link}>
                <Image
                  src={imgUrl}
                  width={240}
                  height={140}
                  layout="responsive"
                  alt={decode(alt || related.title.rendered)}
                />
                <div className="content">{formatPostTitle(related.title.rendered, 65)}</div>
              </a>
            </Link>
          </div>
        );
      })}
    </div>
  );
};

module.exports = RelatedPosts;
